import { ControlContainer } from "@angular/forms";

export function ControlContainerFactory(controlContainer?: ControlContainer) {
  return controlContainer;
}



// WEBPACK FOOTER //
// ./src/app/factories/control-container.factory.ts